export const BRAND_ID = '38676108-A779-4563-AEB4-93C8C356C226';

// Accent (003) still chats via CommunicationHub/Twilio; all other brands use the omnichannel 1-on-1 chat.
export const ACCENT_BRAND_ID = '4B0C292F-5688-4FAA-9C7B-4431B9F0BE54';

